import { styled } from '@mui/material/styles';
import {  Button, TableCell, TableRow, Paper, Link } from '@mui/material';

export const SuggestChangesButton = styled(Link)(({ theme }) => ({
  textTransform: 'none',
  backgroundColor: 'var(--Light-2, #E7EFF5)',
  color: '#002642',
  fontWeight: 'bold',
  borderRadius: '100px',
  padding: theme.spacing(1, 3),
  fontSize: '1rem',
  textDecoration: 'none',
  display: 'inline-block',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#d6e4ed',
    textDecoration: 'none',
  }
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#E7EFF5',
  color: '#333333',
  padding: theme.spacing(1.5, 2),
  border: 'none',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  fontSize: '1rem',
  '&:first-of-type': {
    borderTopLeftRadius: '12px',
    borderBottomLeftRadius: '12px',
    paddingLeft: theme.spacing(3),
  },
  '&:last-child': {
    borderTopRightRadius: '12px',
    borderBottomRightRadius: '12px',
    paddingRight: theme.spacing(3),
  }
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  '& td': {
    backgroundColor: 'white',
    border: 'none',
    padding: theme.spacing(1.5, 2),
  },
  '&:nth-of-type(odd)': {
    '& td': {
      backgroundColor: '#E7EFF5',
    },
    '& td:first-of-type': {
      borderTopLeftRadius: '12px',
      borderBottomLeftRadius: '12px',
      paddingLeft: theme.spacing(3),
    },
    '& td:last-child': {
      borderTopRightRadius: '12px',
      borderBottomRightRadius: '12px',
      paddingRight: theme.spacing(3),
    }
  }
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  border: 'none',
  textAlign: 'left',
  color: '#333333',
  fontSize: '1rem',
  '&:first-of-type': {
    paddingLeft: theme.spacing(3),
  },
  '&:last-child': {
    paddingRight: theme.spacing(3),
  }
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  border: 'none',
  marginTop: theme.spacing(2),
  backgroundColor: 'transparent'
})); 